import { render, staticRenderFns } from "./Header.vue?vue&type=template&id=704fc68a&scoped=true"
import script from "./Header.vue?vue&type=script&lang=js"
export * from "./Header.vue?vue&type=script&lang=js"
import style0 from "./Header.vue?vue&type=style&index=0&id=704fc68a&prod&lang=scss"
import style1 from "./Header.vue?vue&type=style&index=1&id=704fc68a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "704fc68a",
  null
  
)

export default component.exports